export default {
  A1() {
    return 'QUESTIONNAIRE'
  },
  A2() {
    return 'Compulsory questions, please answer'
  },
  A3(num: number) {
    return `At least ${num} of answers`
  },
  A4(num: number) {
    return `At most ${num} answers`
  },
  A5() {
    return `Please fill in the content after 'Other' option`
  },
  A6(num: number) {
    return `No less than ${num} words`
  },
  A7() {
    return `Insufficient words for answers`
  },
  A8() {
    return `Exceeding the maximum number of words`
  },
  A9(num: number) {
    return `${num} stars`
  },
  A10() {
    return `Neutral`
  },
  A11() {
    return `Thank you for filling in, we have prepared a gift for you!`
  },
  A12() {
    return `Previous Question`
  },
  A13() {
    return `Next question`
  },
  A14(num: number) {
    return `Question ${num}`
  },
  A15() {
    return `You have claimed your reward, click on Exit to return to the game.`
  },
  A16() {
    return `Exit`
  },
  A17() {
    return `Other`
  },
  A20() {
    return `Comfirm`
  },
  A21() {
    return `Cancel`
  },
  A25() {
    return `Please enter`
  },
  B(key: keyof ReturnType<typeof getInfomationMap>) {
    return getInfomationMap()[key]
  },
  A26() {
    return 'Activity has expired'
  },
}

function getInfomationMap() {
  return {
    gender: 'gender',
    age: 'age',
    degree: 'degree',
    city: 'city',
    career: 'career',
    income: 'income',
    interest: 'interest',
    marital_status: 'marital status',
    family_members: 'family members',
    personality: 'personality',
    faith: 'faith',
    real_name: 'real name',
    phone: 'phone',
    email: 'email',
    sport: 'sport',
    book: 'book',
    movie: 'movie',
    music: 'music',
    star: 'star',
    interest_city: 'interest city',
    interest_country: 'interest country',
    color: 'color',
    season: 'season',
    plant: 'plant',
    animal: 'animal',
  }
}
